/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// function showGiftNoteCharLimit() {
//   const ta = document.getElementById('cart-note');
//   const maxLength = ta.maxLength;
//   let currentLength = 0;

// //   const updateValue = (e) => {
// //   	console.log('value changed');
// //   }

//   console.log('function ran');

// //   ta.addEventListener('change', () => console.log('updated'));

//   ta.addEventListener("keyup", function(){
//     console.log('updated')
//   });
// }

// Update gift note chars remaining within limit defined in theme settings
const updateGiftNoteValue = (textarea) => {
  const maxLength = textarea.maxLength;
  let currentLength = textarea.value.length;
  const remainingMessage = document.getElementById('cart-note-remaining');

  if (currentLength >= maxLength - 10) {
    remainingMessage.classList.add('Cart-Note__Warning');
  } else {
    remainingMessage.classList.remove('Cart-Note__Warning');
  }

  remainingMessage.innerHTML = `${maxLength - currentLength} remaining.`;
};

// itg js
// if($('.productIframe').length){
//   var playerSrc = document.getElementsByClassName('productIframe')[0].src;
//   if(playerSrc.includes("vimeo")){
//   var mainSrc = playerSrc+';autoplay=1;loop=1;';
//   }else{
//     loopPlay = playerSrc.split('/');
//     var videoId = loopPlay[4].split('?');
//   var mainSrc = playerSrc+'&autoplay=1&playlist='+videoId[0]+'&loop=1;';
//   }
//   setTimeout(function name(params) {
//   document.getElementsByClassName('productIframe')[0].src=mainSrc;
//   },4000)
// }

// if($('.colProductIframe').length){
//   setTimeout(function name(params) {
//     for (let i = 0; i < $('.colProductIframe').length; i++) {
//       var playerSrc = document.getElementsByClassName('colProductIframe')[i].src;
//       if(playerSrc.includes("vimeo")){
//       var mainSrc = playerSrc+';autoplay=1;loop=1;muted=1;autopause=0;controls=0;';
//       }else{
//       loopPlay = playerSrc.split('/');
//       var videoId = loopPlay[4].split('?');
//       var mainSrc = playerSrc+'&autoplay=1&playlist='+videoId[i]+'&loop=1&muted=1;';
//       }
//       document.getElementsByClassName('colProductIframe')[i].src=mainSrc;
//       $('.colProductIframe')[0].contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
//       console.log(mainSrc);
//     }
//   },10)
// }

// Custom JS

/**
 * Creates a debounced version of the provided function.
 * @param {Function} func - The function to debounce.
 * @param {number} wait - The number of milliseconds to delay.
 * @returns {Function} - The debounced function.
 */
function debounce(func, wait) {
  let timeout;

  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func.apply(this, args);
    };

    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

// Unmute PDP video element
// ---------------------------------
const video = $('.native-video');
const unmuteBtn = $('button.unmute');

unmuteBtn.click(() => {
  video[0].paused ? video[0].play() : null;
  video.prop('muted', false);
  unmuteBtn.fadeOut(200);
});

video.click(() => {
  video.prop('muted', true);
  unmuteBtn.fadeIn(200);
});

// mute on gallery change
$('#btnNext, #btnPrev').on('click', () => {
  video.prop('muted', true);
  unmuteBtn.fadeIn(200);
});

// Play video button on content pages
$('.play-native-video-wrapper').each((i, wrapper) => {
  const video = wrapper.querySelector('.native-video')
  const playBtn = wrapper.querySelector('.play')

  playBtn.addEventListener('click', () => {
    video.paused ? (video.play(), video.muted = false, $(playBtn).fadeOut(200)) : null;
  });

  video.addEventListener('click', () => {
    video.paused ? null : (video.pause(), $(playBtn).fadeIn(200));
  });
});

// Header banner slider for mobile
// ---------------------------------

document.addEventListener('DOMContentLoaded', function () {
  document.documentElement.style.setProperty('--header-height', document.getElementById('shopify-section-header').offsetHeight + 'px');
  const isMobile = () => window.innerWidth <= 768;
  const transitionTime = $('.Header__Banner').data('transition-time') || 5000;
  const banners = $('.Header__Banner-Item');
  let currentIndex = 0;
  let intervalId;

  const showBanner = (index) => {
    banners.each((i, banner) => {
      if (i === index) {
        $(banner).fadeIn().addClass('active');
      } else {
        $(banner).fadeOut().removeClass('active');
      }
    });
  };

  const startBannerSlider = () => {
    if (banners.length <= 1) return;

    showBanner(currentIndex);
    intervalId = setInterval(() => {
      currentIndex = (currentIndex + 1) % banners.length;
      showBanner(currentIndex);
    }, transitionTime);
  };

  const stopBannerSlider = () => {
    clearInterval(intervalId);
    banners.each((i, banner) => $(banner).removeClass('active'));
  };

  const handleResize = () => {
    if (isMobile()) {
      startBannerSlider();
    } else {
      stopBannerSlider();
    }
  };

  // Initialize slider
  if (isMobile()) {
    startBannerSlider();
  }


  $(window).resize(debounce(handleResize, 200));
});

// Delivery callout
// ---------------------------------

$(document).ready(() => {
  const deliveryCallout = $('.delivery-callout');
  const calloutText = $('.delivery-callout__text');
  const cutoffMonday = deliveryCallout.data('cutoff-monday');
  const cutoffTuesday = deliveryCallout.data('cutoff-tuesday');
  const cutoffWednesday = deliveryCallout.data('cutoff-wednesday');
  const cutoffThursday = deliveryCallout.data('cutoff-thursday');
  const cutoffFriday = deliveryCallout.data('cutoff-friday');
  const cutoffSaturday = deliveryCallout.data('cutoff-saturday');
  const cutoffSunday = deliveryCallout.data('cutoff-sunday');

  // Work out cut off time for today
  const today = new Date();

  // Work out the cutoff time for today
  const todayCutoff = today.getDay();
  let cutoffTime = null;
  switch (todayCutoff) {
    case 0:
      cutoffTime = cutoffSunday;
      break;
    case 1:
      cutoffTime = cutoffMonday;
      break;
    case 2:
      cutoffTime = cutoffTuesday;
      break;
    case 3:
      cutoffTime = cutoffWednesday;
      break;
    case 4:
      cutoffTime = cutoffThursday;
      break;
    case 5:
      cutoffTime = cutoffFriday;
      break;
    case 6:
      cutoffTime = cutoffSaturday;
      break;
    default:
      cutoffTime = cutoffMonday;
      break;
  }

  // Split cutoff time into hours and minutes
  const cutoffHours = Number(cutoffTime.split(':')[0]);
  const cutoffMinutes = Number(cutoffTime.split(':')[1]);

  if (cutoffHours > 23 || cutoffMinutes > 59 || cutoffHours < 0 || cutoffMinutes < 0) {
    deliveryCallout.hide();
    return;
  }

  // const calculateDeliveryDate = (leadTime) => {
  //   let deliveryDate = new Date();
  //   let daysToAdd = leadTime;

  //   while (daysToAdd > 0) {
  //     deliveryDate.setDate(deliveryDate.getDate() + 1);
  //     const dayOfWeek = deliveryDate.getDay();
  //     if (dayOfWeek !== 0 && dayOfWeek !== 6) {
  //       daysToAdd--;
  //     }
  //   }

  //   return deliveryDate;
  // };

  // const getOrdinalSuffix = (day) => {
  //   const lastDigit = day % 10;
  //   const lastTwoDigits = day % 100;

  //   // Handle 11th, 12th, 13th
  //   if (lastTwoDigits >= 11 && lastTwoDigits <= 13) return 'th';
  //   if (lastDigit === 1) return 'st';
  //   if (lastDigit === 2) return 'nd';
  //   if (lastDigit === 3) return 'rd';
  //   return 'th';
  // };

  // const deliveryDate = calculateDeliveryDate(leadTime);
  // const deliveryDateString = `${deliveryDate.toLocaleDateString('en-GB', {
  //   weekday: 'short',
  //   day: 'numeric',
  //   month: 'short',
  // }).replace(/\d+/, (day) => day + getOrdinalSuffix(day))}`;

  // Function to update the countdown
  const updateCountdown = () => {
    const now = new Date();
    const nowHours = now.getHours();
    const nowMinutes = now.getMinutes();

    // Calculate the difference between the cutoff time and the current time in hours and minutes
    let hours = cutoffHours - nowHours;
    let minutes = cutoffMinutes - nowMinutes;

    // Check if we are past the cutoff time if so tell the user to order tomorrow
    if (hours < 0 || (hours === 0 && minutes < 0) || minutes === 0) {
      calloutText.text('Ships tomorrow if ordered today');
      return;
    }

    if (minutes < 0) {
      hours = (Math.floor(((hours * 60) + minutes) / 60));
      minutes = 60 + minutes;
    }

    if (!calloutText.length) {
      deliveryCallout.hide();
      return;
    }

    let calloutMessage = `Ships today if ordered within `
    if (hours) {
      calloutMessage += `${hours ? hours + ' hr' + (hours > 1 ? 's' : '') + (minutes > 0 ? ' and ' : '') : ''}`;
    }
    if (minutes) {
      calloutMessage += `${minutes ? minutes + ' min' + (minutes > 1 ? 's' : "") : ''}`;
    }

    // Update the countdown text
    calloutText.text(calloutMessage);
  };

  // Initial call to display the countdown immediately
  updateCountdown();

  // Start the countdown and update every 5 seconds
  setInterval(updateCountdown, 5000);
});
